import React from 'react';
import { combineClassNames } from 'core/css';
import { SvgIcon } from 'core/icons';

const NavButton = ({
  as: Type = 'button',
  enable = true,
  className,
  children,
  icon,
  text,
  textClassName,
  ...restProps
}) => {
  if (!enable) {
    return null;
  }
  return (
    <Type
      type={Type === 'button' ? 'button' : null}
      className={combineClassNames(className, 'stat-button-link')}
      data-dtm="global nav"
      {...restProps}>
      {children ? (
        children
      ) : (
        <React.Fragment>
          <SvgIcon name={icon} />
          <span className={textClassName}>{text}</span>
        </React.Fragment>
      )}
    </Type>
  );
};

export default NavButton;
